<div class="" fxLayout="column" fxLayoutGap="50px">
  <span>{{ data | translate }}</span>
  <div class="" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="50px">

    <button
    (click)="onResponseClicked(false)"
    mat-flat-button
    color="primary"
    class="my-button"
  >
    {{ "NO" | translate }}
  </button>
    <button
      (click)="onResponseClicked(true)"
      mat-flat-button
      color="primary"
      class="my-button"
    >
      {{ "YES" | translate }}
    </button>


  </div>
</div>
